
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

interface ResellerPlansSyncButtonProps {
  onSync?: () => void;
}

const ResellerPlansSyncButton: React.FC<ResellerPlansSyncButtonProps> = ({ onSync }) => {
  const { toast } = useToast();
  const [isSyncing, setIsSyncing] = useState(false);

  const handleSyncPlans = () => {
    setIsSyncing(true);
    
    // Simulate a sync operation
    setTimeout(() => {
      setIsSyncing(false);
      
      toast({
        title: "Plans Synchronized",
        description: "Reseller plan data has been synced with Master License",
      });
      
      if (onSync) {
        onSync();
      }
    }, 1500);
  };

  return (
    <Button 
      onClick={handleSyncPlans}
      variant="outline" 
      className="flex items-center gap-2"
      disabled={isSyncing}
    >
      <RefreshCw className={`h-4 w-4 ${isSyncing ? 'animate-spin' : ''}`} />
      {isSyncing ? 'Syncing Plans...' : 'Sync with Master Plans'}
    </Button>
  );
};

export default ResellerPlansSyncButton;
